import { handleError } from '../utils/errorHandler';
import { sanitizeInput } from '../utils/sanitizeInput';
import { Link } from 'react-router-dom';
import { FaSort, FaDownload, FaMapMarkerAlt, FaEye } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { GridFilterModel, GridFilterItem } from '@mui/x-data-grid';
import { DataGrid as DxDataGrid, GridColDef, GridFooterContainer, GridPagination, GridLogicOperator } from '@mui/x-data-grid';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState, useCallback } from 'react';
import { colorsRangeHex, formatNumber,formatNumber2 } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionApp';
import { API_URL, HEIGHT_FOOT, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import './Grilla.css';
import Fechas from './Fechas';
import { apiFetch } from '../apiClient';

let filterAnio = "";
let filterTipoClasificador = "";
let filterCodigoDivipolaPdetRegion = "";
let filterCodigoDivipolaPdetMunicipio = "";
let filterCodigoDivipolaDpto = "";
let filterCodigoDivipolaMpio = "";
let filterSector = "";
let filterEntidad = "";
let filterEsPDET = "";
let filterInternos = "";
let cargado = false;
let listaCantidades: number[] = [];
let currentOrder = "asc";
const T302_LABEL = "Plan de Acción de la Sentencia T-302 de 2017";
const T302_DISPLAY_LABEL = "Sentencia T-302 de 2017";

const mapTipoClasificador = (tipoClasificador: string): string => {
    const tipoClasificadorSafe = tipoClasificador || "";
    if (DEFAULT_FILTER.sentenciaT302 === "1" || tipoClasificadorSafe.includes("T-302")) {
        return T302_DISPLAY_LABEL;
    }
    switch (tipoClasificadorSafe) {
        case "PND":
            return "PND - Plan Nacional de Desarrollo";
        case "PMI":
            return "PMI - Plan Marco de Implementación";
        case "PNS":
            return "PNRRI - Planes Nacionales de la Reforma Rural Integral";
        case "PMI, PNS":
            return "PMI, PNRRI";
        default:
            return tipoClasificadorSafe;
    }
};

const normalizeTipoClasificadorForDetalles = (tipoClasificador: string): string => {
    const tipoClasificadorSafe = tipoClasificador || "";
    if (tipoClasificadorSafe.includes("T-302")) {
        return T302_LABEL;
    }
    if (tipoClasificadorSafe.includes("PND")) {
        return "PND";
    }
    if (tipoClasificadorSafe.includes("PMI, PNRRI")) {
        return "PMI, PNS";
    }
    if (tipoClasificadorSafe.includes("PMI")) {
        return "PMI";
    }
    return "PNS";
};


const localizedTextsMap = {
    columnMenuUnsort: "No clasificado",
    columnMenuSortAsc: "Ordenar de forma ascendente",
    columnMenuSortDesc: "Ordenar de forma descendente",
    columnMenuFilter: "Filtro",
    columnMenuHideColumn: "Ocultar",
    columnMenuShowColumns: "Mostrar columnas",
    noRowsLabel: "No hay indicadores con los criterios seleccionados",
    noResultsOverlayLabel: "No se encontraron resultados.",
    rowsPerPageLabel: "Filas por página:",
    ofLabel: "de",
    errorOverlayDefaultLabel: "Ocurrió un error.",
    toolbarDensity: "Densidad",
    toolbarDensityLabel: "Densidad",
    toolbarDensityCompact: "Compacto",
    toolbarDensityStandard: "Estándar",
    toolbarDensityComfortable: "Cómodo",
    toolbarColumns: "Columnas",
    toolbarColumnsLabel: "Seleccionar columnas",
    toolbarFilters: "Filtros",
    toolbarFiltersLabel: "Mostrar filtros",
    toolbarFiltersTooltipHide: "Ocultar filtros",
    toolbarFiltersTooltipShow: "Mostrar filtros",
    toolbarExport: "Exportar",
    toolbarExportLabel: "Exportar",
    toolbarExportCSV: "Descargar como CSV",
    toolbarExportExcel: "Descargar como Excel",
    toolbarRowsPerPage: "Filas por página:",
    columnsPanelTextFieldLabel: "Buscar columna",
    columnsPanelTextFieldPlaceholder: "Título de la columna",
    columnsPanelDragIconLabel: "Reordenar columna",
    columnsPanelShowAllButton: "Mostrar todo",
    columnsPanelHideAllButton: "Ocultar todo",
    filterPanelAddFilter: "Agregar filtro",
    filterPanelDeleteIconLabel: "Eliminar",
    filterPanelOperators: "Operadores",
    filterPanelOperator: "Operador",
    filterPanelOperatorAnd: "Y",
    filterPanelOperatorOr: "O",
    filterPanelColumns: "Columnas",
    filterPanelInputLabel: "Valor",
    filterPanelInputPlaceholder: "Valor del filtro",
    filterPanelRowsPerPage: "Filas por página:",
    filterOperatorContains: "Contiene",
    filterOperatorDoesNotContain: "No contiene",
    filterOperatorEquals: "Es igual a",
    filterOperatorDoesNotEqual: "Es igual a",
    filterOperatorStartsWith: "Comienza con",
    filterOperatorEndsWith: "Termina con",
    filterOperatorIsEmpty: "Está vacío",
    filterOperatorIsNotEmpty: "Está vacío",
    filterOperatorIsAnyOf: "Es cualquiera de",
    filterOperatorIs: "Es",
    filterOperatorNot: "No es",
    filterOperatorAfter: "Es después de",
    filterOperatorOnOrAfter: "Es en o después de",
    filterOperatorBefore: "Es antes de",
    filterOperatorOnOrBefore: "Es en o antes de",
    filterValueAny: "Cualquiera",
    filterValueTrue: "Verdadero",
    filterValueFalse: "Falso",
    columnMenuLabel: "Menú",
    columnHeaderFiltersLabel: "Mostrar filtros",
    columnHeaderSortIconLabel: "Ordenar",
    footerTotalRows: "Total de Filas:",
    footerRowsPerPage: "Filas por página:",
    footerFirstPage: "Primera página",
    footerPreviousPage: "Página anterior",
    footerNextPage: "Página siguiente",
    footerLastPage: "Última página",
    footerOf: "Siguiente página",
    checkboxSelectionHeaderName: "Selección de casilla",
    booleanCellTrueLabel: "verdadero",
    booleanCellFalseLabel: "falso"
};

class Grid {
    public tipoClasificador: string = "";
    public tipoValor: string = "";
    public idVariable: number = 0;
    public idTipoValor: number = 0;
    public codigo: string = "";
    public indicador: string = "";
    public sector: string = "";
    public entidad: string = "";
    public anio: string = "";
    public meta: number = 0;
    public avancePeriodo: number = 0;
    public avanceDesagregacion: number = 0;
    public unidadMedida: string = "";
    public fechaReporte: Date = new Date();
    public esPDET: boolean = false;
    public EsFichaDepartamental: boolean = true;
    public capaPDETActiva: string = "";
    public codigoDivipolaDpto: string = "";
    public codigoDivipolaMpio: string = "";
    public codigoDivipolaPdetRegion = "";
    public codigoDivipolaPdetMunicipio = "";
    public internos: string = "";
}

interface BarraProps {
    codigoDivipola: string;
    filtrar: string;
    onToggleDetalles: (id: any) => void;
}

const Grilla: React.FC<BarraProps> = ({ codigoDivipola, filtrar, onToggleDetalles }) => {
    const [loading, setLoading] = useState(false);
    const [grilla, setGrilla] = useState<Grid[]>([]);
    const [originalGrilla, setOriginalGrilla] = useState<Grid[]>([]); // Copia original de los datos
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [] as GridFilterItem[],
        logicOperator: GridLogicOperator.And,
    });
    const [filterValues, setFilterValues] = useState<{ [key: string]: string }>({});
    const [pageSize, setPageSize] = useState(15);
    const [pageCurrent, setPage] = useState(0);

    const fetchDatos = async () => {
        try {
            setLoading(true);
            const startTime = performance.now();
            //DEFAULT_FILTER.idVariable= '143';
            //DEFAULT_FILTER.anio= '2024';
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetGrilla?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            // Asegurar que cada fila tenga un id válido
            let idConsecutivo = 0;
            const grillaConIds = data.map((row: any) => ({
                ...row,
                id: `row-${idConsecutivo++}`,
                tipoValor: row.tipoValor === "N/A" ? row.indicador : row.tipoValor,
                tipoClasificador: mapTipoClasificador(row.tipoClasificador)
            }));


            setGrilla(grillaConIds);
            setOriginalGrilla(grillaConIds); // Guardar copia original de los datos
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Grilla Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);

        } finally {
            setLoading(false);
        }
    };

    const updateRenderer = () => { };

    const handleFilterChange = useCallback((field: string, value: string): void => {
        // Sanear la entrada del usuario para prevenir XSS/content spoofing
        const sanitizedValue = sanitizeInput(value);
        // Actualizar valores de filtro
        const newFilterValues = {
            ...filterValues,
            [field]: sanitizedValue,
        };
        setFilterValues(newFilterValues);

        // Actualizar modelo de filtro para el DataGrid
        setFilterModel(prevModel => {
            const newItems = prevModel.items.filter(item => item.field !== field);
            if (sanitizedValue) {
                newItems.push({ field, value: sanitizedValue, operator: 'contains' });
            }
            return {
                ...prevModel,
                items: newItems,
            };
        });

        // Aplicar filtros múltiples a los datos originales
        let filteredData = [...originalGrilla];
        
        // Aplicar todos los filtros activos
        Object.keys(newFilterValues).forEach(filterField => {
            const filterValue = newFilterValues[filterField];
            if (filterValue && filterValue.trim() !== '') {
                filteredData = filteredData.filter(row => {
                    const cellValue = row[filterField as keyof Grid];
                    if (cellValue !== null && cellValue !== undefined) {
                        return cellValue.toString().toLowerCase().includes(filterValue.toLowerCase());
                    }
                    return false;
                });
            }
        });

        // Actualizar los datos mostrados en la grilla
        setGrilla(filteredData);
    }, [filterValues, originalGrilla]);

    // Función para limpiar todos los filtros
    const handleClearFilters = useCallback(() => {
        setFilterValues({});
        setFilterModel({
            items: [],
            logicOperator: GridLogicOperator.And,
        });
        setGrilla([...originalGrilla]);
    }, [originalGrilla]);

    const buidGrid = () => {
        const jumpToIndicador = (indicador: Grid) => {            
            indicador.capaPDETActiva = DEFAULT_FILTER.esPDET;
            indicador.anio = DEFAULT_FILTER.anio;
            indicador.codigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            indicador.codigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            indicador.codigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            DEFAULT_FILTER.internos = "";
            indicador.internos = DEFAULT_FILTER.internos;

            indicador.tipoClasificador = normalizeTipoClasificadorForDetalles(indicador.tipoClasificador);
            onToggleDetalles(indicador);
        };

        const jumpToSite = (indicadorSaltar: Grid) => {
            const tipoClasificador = indicadorSaltar.tipoClasificador;
            const idDestino = indicadorSaltar.idVariable;

            if (tipoClasificador.includes("T-302") || tipoClasificador.includes("Sentencia T-302")) {
                window.open(`https://sinergia20app.dnp.gov.co/ciudadano/detalle-indicador-guajira/${idDestino}`, '_blank');
            } else if (tipoClasificador.includes("PND")) {
                window.open(`https://sinergia20app.dnp.gov.co/ciudadano/detalle-indicador/${idDestino}`, '_blank');
            } else {
                window.open(`https://siipo.dnp.gov.co/detalleindicadorsalto/${idDestino}`, '_blank');
            }
        }

        const minWidth = 150;
        const columns: GridColDef[] = [
            { field: 'tipoClasificador', headerName: 'Instrumento', minWidth: minWidth, filterable: true, headerClassName: 'header-column' },
            { field: 'codigo', headerName: 'Código',  minWidth: minWidth, filterable: true, headerClassName: 'header-column' },
            { field: 'indicador', headerName: 'Indicador', flex: 1, minWidth: minWidth, filterable: true, headerClassName: 'header-column' },
            { field: 'entidad', headerName: 'Entidad Responsable',  minWidth: minWidth, filterable: true, headerClassName: 'header-column' },
            { field: 'unidadMedida', headerName: 'Unidad de Medida',  minWidth: minWidth, filterable: true, headerClassName: 'header-column' },            
            {
                field: 'avancePeriodo',
                headerName: '% Avance Anual',
                minWidth: minWidth,
                headerClassName: 'header-column',
                valueGetter: (value) => {
                    if (value !== null && value !== undefined) {
                        return formatNumber(value);
                    }
                    return '';
                },
            },
            { field: 'tipoValor', headerName: 'Acción Territorial', flex: 1, minWidth: minWidth, filterable: true, headerClassName: 'header-column' },
            {
                field: 'avanceDesagregacion',
                headerName: 'Avance Desagregación',
                minWidth: minWidth,
                headerClassName: 'header-column',
                valueGetter: (value) => {
                    if (value !== null && value !== undefined) {
                        return formatNumber2(value);
                    }
                    return '';
                },
            },
            
            {
                field: 'acciones',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                headerName: 'Acciones',
                minWidth: minWidth,
                renderHeader: () => <CustomHeaderAcciones handleDownload={handleDownload} />,
                renderCell: (params) => {
                    const rowCopy = { ...params.row };
                    return (
                        <div>
                            <button onClick={() => jumpToIndicador(rowCopy)} style={{ border: 'none', background: 'none', marginRight: 15 }} title="Ver desagregación territorial">
                                <FaMapMarkerAlt color="#cccccc" style={{ cursor: 'pointer' }} />
                            </button>
                            <button onClick={() => jumpToSite(rowCopy)} style={{ border: 'none', background: 'none' }} title="Ver detalles del indicador en plataforma">
                                <FaEye color="#cccccc" style={{ cursor: 'pointer' }} />
                            </button>
                        </div>
                    );
                },
            }
        ];

        const CustomHeaderAcciones = ({ handleDownload }: { handleDownload: () => void }) => (
            <div style={{ alignItems: 'center', verticalAlign: 'Top' }}>
                <span style={{ color: '#36c' }}><b>Acciones</b></span>
                <button style={{ border: 'none', background: 'none', marginLeft: 10, cursor: 'pointer' }} onClick={handleDownload}>
                    <FaDownload color="#36c" />
                </button>
                <br /><br />
            </div>
        );

        const handlePageSizeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
            setPageSize(event.target.value as number);
        };

        const PageSizeSelector = () => (
            <div style={{ alignItems: 'center', marginLeft: 20 }}>
                <span style={{ marginRight: 10 }}>Filas por página:</span>
                <select value={pageSize} onChange={handlePageSizeChange} style={{ minWidth: '50px' }}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                </select>
            </div>
        );
        

        const CustomFooter = () => (
            <GridFooterContainer>
                <div style={{ marginLeft: 20, flex: '1 1 auto' }}>
                    <Fechas filtrar={filtrar} codigoDivipola={codigoDivipola} />
                </div>
                <div>
                    <PageSizeSelector />
                </div>
                <div>                    
                    <GridPagination />
                </div>
            </GridFooterContainer>
        );

        return (
            <DxDataGrid
                rows={grilla}
                columns={columns.map(column => ({
                    ...column, disableColumnMenu: false, filterable: true, sortable: true,
                    renderHeader: column.field === 'acciones' ? () => <CustomHeaderAcciones handleDownload={handleDownload} /> : () => (
                        <div>
                            <div style={{ paddingTop: '5px' }}>{column.headerName}</div>
                            <TextField
                                variant="standard"
                                value={filterValues[column.field] || ''}
                                onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                placeholder={`Filtrar ${column.headerName}`}
                                InputProps={{
                                    style: { fontSize: '10px' },
                                }}
                            />
                        </div>
                    ),
                }))}
                rowHeight={35}
                columnHeaderHeight={55}
                localeText={localizedTextsMap}
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: pageSize, page: 0 },
                    },
                }}
                paginationModel={{ pageSize: pageSize, page: pageCurrent }}
                pageSizeOptions={[5, 10, 15, 20, 25]}
                
                onPaginationModelChange={(model) => {
                    setPageSize(model.pageSize);
                    setPage(model.page);
                }}
                
                slots={{
                    footer: CustomFooter,
                }}
                density="compact"
                filterModel={filterModel}
                onFilterModelChange={(model) => setFilterModel(model)}
                sx={{
                    '& .MuiDataGrid-cell': {
                        fontSize: '10px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        fontSize: '12px'
                    },
                    '& .MuiDataGrid-root': {
                        overflowX: 'hidden',
                    },
                }}
            />
        );
    }

    const handleDownload = () => {
        const XLSX = require('xlsx');
        const filteredGrilla = grilla.map(({ tipoClasificador, codigo, indicador,entidad,  unidadMedida, avancePeriodo, tipoValor, avanceDesagregacion }) => ({
            tipoClasificador, codigo, indicador, entidad,  unidadMedida,  avancePeriodo,tipoValor,avanceDesagregacion
        }));

        const worksheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(worksheet, [
            ['Instrumento', 'Código', 'Indicador', 'Entidad Responsable','Unidad de Medida', '% Avance Anual','Acción Territorial', 'Avance Desagregación'  ]
        ], { origin: 'A1' });
        XLSX.utils.sheet_add_json(worksheet, filteredGrilla, { origin: 'A2', skipHeader: true });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Grilla');

        const filtrosSeleccionados = Object.keys(DEFAULT_FILTER)
            .filter(key => {
                const value = DEFAULT_FILTER[key as keyof ArcFiltros];
                return value !== "" && (typeof value !== 'number' || value > 0);
            })
            .map(key => `${key}-${DEFAULT_FILTER[key as keyof ArcFiltros]}`)
            .join('_');

        const nombreArchivo = `grilla_${DEFAULT_FILTER.anio}_${filtrosSeleccionados}.xlsx`;
        XLSX.writeFile(workbook, nombreArchivo);
    };

    const getDatos = async () => {
        if (!cargado) {
            if (DEFAULT_FILTER.anio != filterAnio
                || DEFAULT_FILTER.tipoClasificador != filterTipoClasificador
                || filterCodigoDivipolaPdetRegion != DEFAULT_FILTER.codigoDivipolaPdetRegion
                || filterCodigoDivipolaPdetMunicipio != DEFAULT_FILTER.codigoDivipolaPdetMunicipio
                || DEFAULT_FILTER.codigoDivipolaDpto != filterCodigoDivipolaDpto
                || DEFAULT_FILTER.codigoDivipolaMpio != filterCodigoDivipolaMpio
                || DEFAULT_FILTER.sector != filterSector
                || DEFAULT_FILTER.entidad != filterEntidad
                || DEFAULT_FILTER.esPDET != filterEsPDET
            ) {
                filterAnio = DEFAULT_FILTER.anio;
                filterTipoClasificador = DEFAULT_FILTER.tipoClasificador;
                filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
                filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
                filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
                filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
                filterSector = DEFAULT_FILTER.sector;
                filterEntidad = DEFAULT_FILTER.entidad;
                filterEsPDET = DEFAULT_FILTER.esPDET;
                fetchDatos().then(() => {
                    // Limpiar filtros cuando se recargan los datos
                    setFilterValues({});
                    setFilterModel({
                        items: [],
                        logicOperator: GridLogicOperator.And,
                    });
                    updateRenderer();
                });
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola]);

    if (loading) {
        return (
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                padding: '20px',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center'
            }}>
                <div style={{
                    border: '4px solid #f3f3f3',
                    borderRadius: '50%',
                    borderTop: '4px solid #3498db',
                    width: '40px',
                    height: '40px',
                    animation: 'spin 2s linear infinite'
                }}></div>
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
                <span style={{ marginLeft: '10px', color: '#fff' }}>Cargando...</span>
            </div>

        );
    }
    else {
        return (
            <div style={{ height: HEIGHT_FOOT, borderRadius: '10px', border: '1px solid #f0f0f0' }}>
                {buidGrid()}
            </div>
        );
    }
};

export default Grilla;